import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter, useNavigate } from 'react-router-dom';
import { BotStoreProvider } from './Store';
import { BotPage } from './bots/BotPage';
import { BotList } from './bots/bot-list';
import { AlertContainer } from './components/AlertContainer';
import { useConfirm, usePrompt } from './components/Dialogs';
import { Modal } from './components/Modal';
import { useAddToast } from './components/Toasts';
import { AudienceIndex } from './audience/audience-index';
import { MediaPage } from './media/media-page';

function TestPrompt(){
    const dialog = useConfirm("Tem certeza?", {buttonClass:"btn-danger", ok: <><i className='fa fa-exclamation-triangle me-1'></i> Ok</>});
    const addToast = useAddToast();

    async function show(){
        var x = await dialog()
        console.log(x)
    }

    async function testToast(){
        addToast("Erro", 'bg-danger');
    }

    return <>
        <button onClick={show} className='btn btn-secondary me-2'>Oi</button>
        <button onClick={testToast} className='btn btn-primary'>Toast</button>
    </>
}

function DialogButton(){
    const [show, setShow] = useState(false);
    const dialog = usePrompt("Qual seu nome?", {value:"Douglas", placeholder: "Nome completo..."});
    const alert = useConfirm(<>Tudo <b>Certo</b> cara?</>, {});
    const attention = useConfirm(<>Tudo <b>Certo</b> cara?</>, {title: "Atenção"});
    const navigate = useNavigate();
    
    useEffect(() => {
        console.log("Dialog Test button created")
    }, [])

    return <div className='container my-4'>
        <button className='btn btn-primary me-2' onClick={() => navigate(-1)}>Volteition</button>
        <button className='btn btn-primary me-2' onClick={() => setShow(true)}>Test</button>
        <button className='btn btn-primary me-2' onClick={() => alert()}>Confirm</button>
        <button className='btn btn-primary me-2' onClick={() => attention()}>Attention</button>
        <button className='btn btn-primary' onClick={() => dialog()}>Prompt</button>
        {
            show && 
            <Modal title="Test alerts" onHide={() => setShow(false)}>
                <TestPrompt />
            </Modal>
        }
    </div>
}


const router = createBrowserRouter([
    {
        path: "/",
        element: <BotList />
    }, {
       path: "/test-dialog",
       element: <DialogButton /> 
    }, {
       path: "/publico/*",
       element: <AudienceIndex /> 
    }, {
        path: "/bot/:botId/*",
        element: <BotPage /> 
    },{
        path: "/midia/*",
        element: <MediaPage /> 
    }
], {basename: location.host.match(/cnec/) ? '/wa' : '/'})


function createApp(){
    var r = createRoot(document.querySelector('#root'));
    r.render(<AlertContainer>
        <BotStoreProvider>
            <RouterProvider router={router} />
        </BotStoreProvider>
    </AlertContainer>);
}

window.addEventListener("DOMContentLoaded", createApp);